var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmpp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.559,
    height: 55.661,
    viewBox: "0 0 76.559 55.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4001.832 5200)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.227,21.578c.034.574-.782.424-.782,1,0,16.867-20.37,42.6-40.115,47.572v.717c26.231-2.415,56.248-29.664,56.908-55.5L99.225,21.578Z",
    transform: "translate(3963.153 -5215.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M91.089,29.351c.033.574.052,1.151.052,1.731,0,16.867-13.431,39.594-33.176,44.566v.717C83.8,75.145,104.26,48.791,104.26,28.588A29.714,29.714,0,0,0,104.1,25.5L91.09,29.35Z",
    transform: "translate(3963.358 -5221.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M104.206,24.95l-3.333,1.191c.018.421.029.986.029,1.411,0,18.034-16.307,42.966-38.183,46.867-1.42.476-3.3.909-4.783,1.282v.717c28.55-2.433,48.609-31.443,46.272-51.47Z",
    transform: "translate(3963.375 -5220.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.427,21.577c-.034.574.782.424.782,1,0,16.867,20.37,42.6,40.115,47.572v.717C44.094,68.453,14.077,41.2,13.416,15.369l16.013,6.208Z",
    transform: "translate(3988.416 -5215.369)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.211,29.35c-.033.574-.053,1.151-.053,1.731,0,16.867,13.431,39.594,33.176,44.566v.717C58.5,75.144,38.04,48.79,38.04,28.587A29.715,29.715,0,0,1,38.2,25.5L51.21,29.349Z",
    transform: "translate(3974.565 -5221.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.885,24.949l3.333,1.191c-.018.421-.029.986-.029,1.411,0,18.034,16.307,42.966,38.183,46.867,1.42.476,3.3.909,4.783,1.282v.717C55.6,73.984,35.546,44.974,37.882,24.947Z",
    transform: "translate(3974.758 -5220.756)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmpp);
export default __webpack_public_path__ + "static/media/xmpp.a873dafc90277c5fa4602aa5e20f4509.svg";
export { ForwardRef as ReactComponent };